import Grid from "@mui/material/Grid/Grid";
import {
    CustomLabelMediumBold,
    CustomLabelMediumSmallBold,
    CustomLabelRegularLargeMedium,
    CustomLabelSmallMedium
} from "../common/CustomLabel";
import Paper from "@mui/material/Paper/Paper";
// import INNOVATION from "../../assets/images/innovation.png";
import MAIL_OUT from "../../assets/images/mail-out.png";
import React from "react";
// import SCAM_FREE_HIRING from "../../assets/icons/ScamFreeHiring.png";
import DEVELOPER_REPLACEMENT from "../../assets/icons/DeveloperReplacement.png";
import INSTANT_TALENT_ACCESS from "../../assets/icons/TalentAccess.png";
import PROJECT_BI_EQUITY from "../../assets/icons/ProjectByEquity.png";
import EXCLUSIVE_DISCOUNTS from "../../assets/icons/Discount.png";
import CONTINUOUS_SUPPORT from "../../assets/icons/ContinuousSupport.png";
import { Box, useMediaQuery, useTheme } from "@mui/material";

const servicesData = [
    // {
    //     icon: SCAM_FREE_HIRING,
    //     title: "Scam-Free Hiring",
    //     description: "No fake resumes, no hidden fees—just verified, top-tier developers ready to deliver.",
    //     padding: { xs: "20px", md: "20px 25px", lg: "20px 40px" }
    // },
    {
        icon: DEVELOPER_REPLACEMENT,
        title: "Developer Replacement",
        description: "Not satisfied? Easily swap developers without delays or extra costs.",
        padding: { xs: "20px", md: "20px 25px", lg: "20px 40px" }
    },
    {
        icon: INSTANT_TALENT_ACCESS,
        title: "Instant Talent Access",
        description: "Onboard skilled professionals immediately and replace developers within a week if unsatisfied.",
        padding: { xs: "20px", md: "20px 25px", lg: "20px 40px" }
    },
    {
        icon: PROJECT_BI_EQUITY,
        title: "Project by Equity",
        description: "We invest our expertise in high-potential ideas, eliminating upfront costs and sharing success.",
        padding: { xs: "20px", md: "20px 25px", lg: "20px 40px" }
    },
    {
        icon: EXCLUSIVE_DISCOUNTS,
        title: "Exclusive Discounts",
        description: "Get 10% off your first developer hire and 15% off full project development.",
        padding: { xs: "20px", md: "20px 25px", lg: "20px 40px" }
    },
    {
        icon: CONTINUOUS_SUPPORT,
        title: "Continuous Support",
        description: "From development to post-launch, we provide long-term technical assistance.",
        padding: { xs: "20px", md: "20px 25px", lg: "20px 40px" }
    }
];

const WhatMakeUsDifferent = ({setShowWhatService}) => {
    const [showAll, setShowAll] = React.useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    
    const displayedServices = React.useMemo(() => {
        if (showAll || !isMobile) {
            return servicesData;
        }
        return servicesData.slice(0, 3);
    }, [showAll, isMobile]);

    return (
        <Grid container sx={{paddingBottom: {xs: "30px", md: "50px"}, px :{ xs: 1, md: 5}}} justifyContent={"center"}>
            <Grid item container justifyContent={"center"} sx={{
                marginTop: {xs: "0px", md: "50px"},
                textAlign: {xs: "center", md: "center"}
            }}>
                <CustomLabelMediumBold text={"At OSTRYX – YOUR SUCCESS, OUR PRIORITY"} fontWeight={700} color={"#5E17EB"}/>
            </Grid>

            {/* <Grid item container justifyContent={"space-between"} */}
            <Grid container spacing={4} justifyContent="center"
                  sx={{padding: {xs: "0px 10px", md: "0px 40px"}, marginTop: {xs: "10px", md: "10px"}}}>

                {displayedServices.map((service, index) => (
                    <Grid item xs={12} md={5.8} lg={4} style={{marginTop: "10px"}} key={index}>
                        <Paper 
                            style={{width: "100%", background: "#FAF7FF", borderRadius: 25}}
                            sx={{
                                height: { md: '100%' },  // Full height on md and up
                                display: 'flex',         // Enable flex layout
                                flexDirection: 'column',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'translateY(-5px)',
                                    '& .hover-image': {
                                        filter: 'grayscale(0%)',
                                    },
                                    // '& .css-5lhuyz-MuiTypography-root':{ 
                                    //     color: '#5E17EB', 
                                    // }
                                },
                                '& .MuiGrid-item:nth-of-type(2) .MuiTypography-root': {
                                filter: 'grayscale(100%)',
                                transition: 'filter 0.3s ease-in-out',
                                },
                                '&:hover .MuiGrid-item:nth-of-type(2) .MuiTypography-root': {
                                    filter: 'grayscale(0%)',
                                    color: '#5E17EB',
                                },
                            }}
                        >
                            <Grid 
                                item 
                                container 
                                alignItems={"center"} 
                                direction={"column"}
                                sx={{
                                    padding: service.padding,
                                    height: '100%',  // Take full height
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center' 
                                }}
                            >
                                <Grid item sx={{ mt: 1.25, display: 'flex', justifyContent: 'center' }}>
                                    <Box
                                        component="img"
                                        src={service.icon}
                                        alt={service.title}
                                        className="hover-image"
                                        sx={{
                                            width: { xs: '50%', sm: '60%', md: '70%' },
                                            height: 'auto',
                                            maxHeight: { md: '180px' },  // Control image height
                                            borderRadius: '25px',
                                            // filter: 'grayscale(100%)',
                                            transition: 'filter 0.3s',
                                            display: 'block',
                                            margin: { xs: '0 auto', md: '0' },
                                            objectFit: 'contain',
                                        }}
                                    />
                                </Grid>
                                <Grid item 
                                    sx={{
                                        marginTop: {xs: "10px", md: "20px"},
                                        textAlign: 'center',
                                        width: '100%'
                                    }}
                                >
                                    <CustomLabelMediumSmallBold 
                                        text={service.title}
                                        // className="hover-title"
                                        sx={{
                                            fontSize: { md: '1rem', lg: '1.1rem' },
                                            lineHeight: { md: 1.2 },
                                            transition: 'color 0.3s ease',
                                            color: '#5E17EB'
                                        }}
                                    />
                                </Grid>
                                <Grid item 
                                    sx={{
                                        marginTop: "5px",
                                        flex: 1,          // Take remaining space
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}
                                >
                                    <CustomLabelRegularLargeMedium
                                        text={service.description}
                                        color={"black"}
                                        normal={false}
                                        sx={{
                                            fontSize: { md: '0.9rem', lg: '1rem' },
                                            lineHeight: { md: 1.4, lg: 1.5 },
                                            textAlign: 'center',
                                            display: '-webkit-box',
                                            WebkitLineClamp: { md: 3, lg: 4 },
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden'
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                ))}

                {/* Show More/Less Button for mobile */}
                <Grid item xs={12} container justifyContent={"center"} sx={{ mt: 3, display: { md: 'none' } }}>
                    <Grid item xs={9} container justifyContent={"center"}
                        sx={{
                            border: "1.5px solid #5E17EB",
                            borderRadius: 15,
                            padding: "12px 25px",
                            cursor: "pointer"
                        }}
                        onClick={() => setShowAll(!showAll)}
                    >
                        <CustomLabelSmallMedium 
                            text={showAll ? "Show Less" : "Show More"} 
                            color={"#5E17EB"}
                        />
                    </Grid>
                </Grid>

                <Grid item xs={12} container justifyContent={"center"}
                      sx={{marginTop: {xs: "20px", md: "60px"}}}>
                    <Grid item xs={9} md={6} lg={3} container justifyContent={"center"} 
                          sx={{
                              border: "1.5px solid #F5F5F5",
                              borderRadius: 15,
                              padding: "12px 25px",
                              background: "#5E17EB",
                              cursor: "pointer"
                          }}
                          alignItems={"center"} 
                          onClick={() => setShowWhatService(true)}>
                        <Grid item>
                            <Box component="img" src={MAIL_OUT} alt="Mail Out" />
                        </Grid>
                        <Grid item sx={{ ml: 1 }}>
                            <CustomLabelSmallMedium text={"Schedule a Consultation"} color={"white"}/>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default WhatMakeUsDifferent;
